import { z } from 'zod';

/**
 * How a grant was actually spent (`03-courses-discounts.md` §Data model).
 *
 * `direct` — a staff-recorded payment, where the discount is applied natively at
 * order entry and the grant is claimed on confirmation (matrix row 15).
 * `iap_offer_code` — an Apple/Google offer code handed out against the grant and
 * marked redeemed on webhook evidence of the discounted purchase (row 16).
 *
 * Both channels belong to **billing** (P23), which owns orders and the webhook.
 * The channel is declared here because the `discount_redemptions` row is a
 * `courses` row: the module that issued the value records how it left.
 */
export const REDEMPTION_CHANNELS = ['direct', 'iap_offer_code'] as const;

export const RedemptionChannelSchema = z.enum(REDEMPTION_CHANNELS);

export type RedemptionChannel = (typeof REDEMPTION_CHANNELS)[number];

const CHANNEL_SET: ReadonlySet<string> = new Set(REDEMPTION_CHANNELS);

export function isRedemptionChannel(value: string): value is RedemptionChannel {
  return CHANNEL_SET.has(value);
}
